/** BEGIN CONTACT INFORMATION */
const FULL_NAME = [
  ['First name', 'firstName'],
  ['Last name', 'lastName'],
]
const validateName = errors => !(errors['firstName'] || errors['lastName'])

const DOB = [['Date of Birth', 'dateOfBirth']]
const validateDob = errors => !errors['dateOfBirth']

const ADDRESS = [
  ['Address Line 1', 'addressLine1'],
  ['Address Line 2 (optional)', 'addressLine2'],
  ['City', 'city'],
  ['State', 'state'],
  ['Zip code', 'zipCode'],
]
const validateAddress = errors =>
  !(
    errors['addressLine1'] ||
    errors['city'] ||
    errors['state'] ||
    errors['zipCode']
  )

const CONTACT_DETAILS = [
  ['Phone', 'phoneNumber'],
  ['Secondary phone (optional)', 'alternatePhoneNumber'],
  ['Email', 'email'],
  ['Secondary email (optional)', 'alternateEmail'],
]
const validateContactDetails = errors =>
  !(errors['phoneNumber'] || errors['email'])

const GENDER = ['Female', 'Male', 'Other', 'Prefer not to say']

const ETHNICITY = [
  'American Indian or Alaskan Native',
  'Asian',
  'Black or African American',
  'Hispanic',
  'Multiracial',
  'Native Hawaiian or Other Pacific Islander',
  'White',
]

const EDUCATION = [
  'Advanced Degree',
  'College Degree',
  'Some College',
  'High School/GED',
  'Some High School',
  'None',
  'Prefer not to say',
]

const EMERGENCY_CONTACT = [
  ['Emergency Contact Name', 'emergencyContactName'],
  ['Emergency Contact Phone', 'emergencyContactPhoneNumber'],
  ['Emergency Contact Relation', 'emergencyContactRelation'],
]
const validateEmergencyContact = errors =>
  !(
    errors['emergencyContactName'] ||
    errors['emergencyContactPhoneNumber'] ||
    errors['emergencyContactRelation']
  )

const EMPLOYER_DETAILS = [
  ['Employer name', 'employerName'],
  ['Employeer address', 'employerAddress'],
]
const validateEmployerDetails = errors =>
  !(errors['employerName'] || errors['employerAddress'])
/** END CONTACT INFORMATION */

/** BEGIN VOLUNTEER PREFERENCES */
const SCHOOL = [
  'No preference',
  'Academy For Integrated Arts',
  'Boone Elementary School',
  'Brookside Charter School',
  'Citizens of the World Charter School',
  'Crossroads Academy Central Street',
  'Crossroads Academy Quality Hill',
  'Garfield Elementary School',
  'Genesis Charter School',
  'Hope Leadership Academy',
  'Indian Creek Elementary School',
  'King Elementary School',
  'KIPP KC',
  'Longfellow Elementary School',
  'Primitivo Garcia Elementary School',
  'Wendell Phillips Elementary School',
  'Whittier Elementary School',
]
const SCHOOL_DISTRICT = [
  'No Preference',
  'Center School District',
  'Charter Schools',
  'Kansas City Kansas Public Schools',
  'Kansas City Missouri Public Schools',
]
const FREQUENCY = [
  'Assigned, every week',
  'Shared, twice a month',
  'Flextra, at least once a month',
]
const AVAILABILITY = ['Tuesdays', 'Wednesdays', 'Thursdays']
const SKILLS = [
  'Reading mentor',
  'Bilingual',
  'Computer usage',
  'Event planning',
  'Fundraising',
  'Marketing',
]
const HEAR_ABOUT_US = [
  'Advertisement',
  'Family or friend',
  'Employee Referral',
  'External Referral',
  'KMBC',
  'Partner',
  'Public Relations',
  'Seminar – Internal',
  'Seminar – Partner',
  'Trade Show',
  'Word of mouth',
]
/** END VOLUNTEER PREFERENCES */

/** BEGIN SHARED VOLUNTEER */
const SHARED_VOLUNTEER =
  'Shared volunteers: If you and a friend or colleague are sharing a student for the school year, please provide their name and contact information below. Both volunteers need to complete this online application and background screening.'
const SHARED_VOLUNTEER_INFO = [
  ['Shared Volunteer Name (optional)', 'sharedVolunteerName'],
  ['Shared Volunteer Phone (optional)', 'sharedVolunteerPhone'],
  ['Shared Volunteer Email (optional)', 'sharedVolunteerEmail'],
]
/** BEGIN SHARED VOLUNTEER */

const BACKGROUND_QUESTIONS = [
  [
    'Have you ever been convicted of a crime other than a traffic violation?',
    'trafficViolation',
  ],
  ['Any felony or misdemeanor?', 'felonyOrMisdemeanor'],
  ['Any DUI/DWI?', 'duiDwi'],
  ['Is your driver’s license suspended?', 'licenseSuspended'],
  [
    'Any felony, misdemeanor or municipal charges pending against you?',
    'pendingCharges',
  ],
  [
    'Have there ever been allegations, complaints or reports regarding your involvement in child abuse or neglect?',
    'abuseOrNeglect',
  ],
]
const BACKGROUND_QUESTIONS_IF_YES = `If you answered yes to any of the question
  above, please provide the date, description, and explanation of each incident.`
// TODO(etnichols): Figure out how to validate.
const validateBackgroundQuestions = errors => true

const REFERENCES =
  'Please list two references of people who know you well, other than relatives, preferably people you have worked for in either a paid or volunteer capacity.'
const REFERENCE_1 = [
  ['Name', 'reference1Name'],
  ['Email', 'reference1Email'],
  ['Phone', 'reference1Phone'],
  ['Relation', 'reference1Relation'],
]
const REFERENCE_2 = [
  ['Name', 'reference2Name'],
  ['Email', 'reference2Email'],
  ['Phone', 'reference2Phone'],
  ['Relation', 'reference2Relation'],
]
const validateReference1 = errors =>
  !(
    errors['reference1Name'] ||
    errors['reference1Email'] ||
    errors['reference1Phone'] ||
    errors['reference1Relation']
  )
const validateReference2 = errors =>
  !(
    errors['reference2Name'] ||
    errors['reference2Email'] ||
    errors['reference2Phone'] ||
    errors['reference2Relation']
  )

const AUTHORIZATION_AND_CONSENT = `I declare that all the statements I have made on this application are true, correct, and complete to the best of my knowledge. I understand that any omissions or misstatements made by me on this application may be cause for my application to be declined or volunteer placement to be terminated. I understand that all information, including driver’s license, criminal background, and child abuse/neglect records and sex offender registry, will be verified and hereby consent to such verification. You have my permission to contact my employer. I understand that the school district, at its sole and complete discretion, may accept or decline this application without providing me any reasons for the decision. I agree to receive periodic communications from Lead to Read KC.`

const READ_CODE_OF_CONDUCT = `I have read and agree to Lead to Read Code of Conduct.`
const APPLICANT_SIGNATURE = `Please type your full name`

export {
  FULL_NAME,
  validateName,
  DOB,
  validateDob,
  ADDRESS,
  validateAddress,
  CONTACT_DETAILS,
  GENDER,
  EDUCATION,
  ETHNICITY,
  validateContactDetails,
  EMERGENCY_CONTACT,
  validateEmergencyContact,
  EMPLOYER_DETAILS,
  validateEmployerDetails,
  SCHOOL,
  SCHOOL_DISTRICT,
  FREQUENCY,
  AVAILABILITY,
  SKILLS,
  HEAR_ABOUT_US,
  SHARED_VOLUNTEER,
  SHARED_VOLUNTEER_INFO,
  BACKGROUND_QUESTIONS,
  BACKGROUND_QUESTIONS_IF_YES,
  validateBackgroundQuestions,
  REFERENCES,
  REFERENCE_1,
  REFERENCE_2,
  validateReference1,
  validateReference2,
  AUTHORIZATION_AND_CONSENT,
  READ_CODE_OF_CONDUCT,
  APPLICANT_SIGNATURE,
}
